import React, { useState } from 'react';
import './App.css'; // Import the CSS file for styling


function MessageInput({ onSendMessage }) {

  const [message, setMessage] = useState('');
  const [username, setUsername] = useState('');
  const handleSubmit = (event) => {

    event.preventDefault();

    if (message.trim() !== '') {
      onSendMessage({ user: username, content: message });
      setMessage('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="message-input-form">
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center', }}>
      <input
        style={{width:"200px"}}
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="name..."
        className="message-input-field"
      />
      <input
        type="text"
        style={{
          width: "300px",
        }}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Type your cosmic message..."
        className="message-input-field"
      />
      <button type="submit" className="message-send-button">Send</button>
      </div>
    </form>
  );
}

export default MessageInput;